import React, {useContext, useState} from "react";
import { Form, Button, Spinner } from "react-bootstrap";
import { setAffiliateModelApi } from "../../http/affiliateAPI"; // обнови путь при необходимости
import { toast } from "react-toastify";
import {Context} from "../../index";
import auth from "../../pages/public/Auth/Auth";
import {check} from "../../http/userAPI";
import AffiliateEarningsCalculator from "./AffiliateCalculator";

const SetAffiliateModel = ({ userId }) => {
    const models = [
        { value: "OFF", label: "Affiliate Model: VIRT" },
        { value: "ONETIME-50", label: "Affiliate Model: ONETIME-50" },
        { value: "1Y-20", label: "Affiliate Model: 1Y-20" },
        { value: "2Y-15", label: "Affiliate Model: 2Y-15" },
        { value: "3Y-10", label: "Affiliate Model: 3Y-10" },
        { value: "5Y-5", label: "Affiliate Model: 5Y-5" },

    ];
    const { user } = useContext(Context);
    const [selectedModel, setSelectedModel] = useState(user?.user?.affiliate_model || "OFF");
    const [loading, setLoading] = useState(false);


    const handleSave = async () => {
        if (!userId || !selectedModel) return;
        setLoading(true);
        try {
            const response = await setAffiliateModelApi({ userId, model: selectedModel });
            toast.success(response.message || "Affiliate model saved.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            const data = await check();
            user.setUser(data);

        } catch (e) {
            toast.error("Failed to save affiliate model.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } finally {
            setLoading(false);
        }
    };

    const getModelDescription = (model) => {
        switch (model) {
            case "OFF":
                return (
                    <>
                        VIRT – This is the default affiliate model active for all users after registration. It rewards you in Virts — the internal currency of the platform — instead of real money.
                        <br />
                        <strong>You earn rewards in two steps:</strong>
                        <br /><strong>+50 Virt</strong> when someone registers using your link and stays on the Free plan.
                        <br /><strong>One-time bonus</strong> when they upgrade to a paid plan:
                        <br /><strong>+950 Virt</strong> for ESSENTIAL (total: 1000 Virt)
                        <br /><strong>+1950 Virt</strong> for PREMIUM (total: 2000 Virt)
                        <br /><strong>+2950 Virt</strong> for MAXIMUM (total: 3000 Virt)
                        <br />
                        These bonuses are credited once per user and appear in your account right after payment confirmation.
                        <br />
                        <strong>Why it’s awesome:</strong>
                        <br />
                        This model is perfect if you're focused on getting more reviews for your books. The more Virts you have, the more assignments you can post — which means more readers, more feedback, and better visibility for your titles.
                        <br />
                        It’s a great option for authors and publishers who want to reinvest referral rewards directly into promoting their books.
                        <br />
                        You build your audience and get rewarded in a currency you can immediately use on the platform.
                    </>
                );

            case "ONETIME-50":
                return (
                    <>
                        ONETIME-50 – This is a direct, one-level referral model. You get a single bonus payment when a user you invited makes their very first payment.
                        <br />
                        <strong>You get:</strong>
                        <br />+ 50% from your referral’s first payment — no matter what it is: subscription, balance top-up, or other.
                        <br />
                        This reward is one-time and only applies to the very first payment made by the user. After that, you don’t earn from this user anymore.
                        <br />
                        All rewards are calculated after payment system fees are deducted, and shown clearly in your reports.
                        <br />
                        <strong>Why it’s awesome:</strong>
                        <br />
                        If you want fast money from referrals — this is probably the best option. You don’t have to wait months to earn. Just bring in users who are ready to pay, and you instantly get 50% of their first transaction.
                        <br />
                        It’s simple, instant, and powerful. You can use this model in one-time promo campaigns, influencer drops, or giveaways. It’s especially great if you’re running traffic or content that generates quick action.
                        <br />
                        No long-term tracking or multi-level chains — just direct results and big upfront rewards.
                    </>
                );

            case "1Y-20":
                return (
                    <>
                        1Y-20 – This is a 3-level referral model. You earn rewards from people who sign up using your link, and also from people they invite (level 2), and even from those users’ invites (level 3).
                        <br />
                        <strong>You get:</strong>
                        <br />+ 20% from all payments made by people you directly invited (level 1)
                        <br />+ 10% from payments made by level 2 users
                        <br />+ 5% from payments made by level 3 users
                        <br />
                        Rewards are counted from both subscription payments and account top-ups. But there is a time limit — rewards are paid for exactly 1 year from the date each user makes their first payment. After 1 year, no more rewards from that user.
                        <br />
                        All rewards are calculated after payment system fees are deducted. You’ll see full details in your reports.
                        <br />
                        In total, you can <strong>earn up to 35%</strong> across all levels during the first year of a user’s payments.
                        <br />
                        <strong>Why it’s awesome:</strong>
                        <br />
                        This model gives you the chance to build a real micro-network. It’s not just about one-time invites — your rewards grow automatically when others start inviting too. It’s passive income at its best!
                        <br />
                        You can earn while you sleep — literally. Once your referral tree starts growing, the system works for you. The more people benefit from Virtalibry, the more you do too. That’s win-win!
                    </>
                );
            case "2Y-15":
                return (
                    <>
                        2Y-15 – This is a 3-level referral model. You earn rewards from people who sign up using your link, and also from people they invite (level 2), and even from those users’ invites (level 3).
                        <br />
                        <strong>You get:</strong>
                        <br />+ 15% from all payments made by people you directly invited (level 1)
                        <br />+ 7.5% from payments made by level 2 users
                        <br />+ 3.75% from payments made by level 3 users
                        <br />
                        Rewards include both subscription payments and balance top-ups. There’s a time limit — rewards are paid for exactly 2 years from the moment each user makes their first payment. After that, rewards for that user stop.
                        <br />
                        All commissions are calculated after deducting payment system fees. You’ll be able to track everything in your reports.
                        <br />
                        In total, you can <strong>earn up to 26.25%</strong> across all levels during the first 2 years of a user’s payments.
                        <br />
                        <strong>Why it’s awesome:</strong>
                        <br />
                        This model gives you stable income over a longer period. Instead of fast one-time gains, you’re building a stream that pays out for 24 months per user. It rewards consistency and long-term value.
                        <br />
                        It’s a great balance between passive income and meaningful reward rates, and lets your network grow naturally over time.
                    </>
                );

            case "3Y-10":
                return (
                    <>
                        3Y-10 – This is a 3-level referral model. You earn rewards from users who sign up using your link, and also from users they invite (level 2), and from level 3 referrals as well.
                        <br />
                        <strong>You get:</strong>
                        <br />+ 10% from all payments made by your direct invites (level 1)
                        <br />+ 5% from payments made by level 2 users
                        <br />+ 2.5% from payments made by level 3 users
                        <br />
                        The rewards include both subscriptions and balance top-ups. Rewards are paid for exactly 3 years starting from the moment a user makes their first payment. After 3 years, no further rewards from that user.
                        <br />
                        All calculations are made after payment system fees are subtracted. Full details will be shown in your reports.
                        <br />
                        In total, you can <strong>earn up to 17.5%</strong> across all levels over the course of 3 years per user.
                        <br />
                        <strong>Why it’s awesome:</strong>
                        <br />
                        This model is designed for long-term thinkers. You build a network once and keep earning for years. It's lower percentage per payment — but it lasts longer, giving you steady, passive income over time.
                        <br />
                        Great if you're planning to grow your presence gradually and earn from your community for the long haul.
                    </>
                );

            case "5Y-5":
                return (
                    <>
                        5Y-5 – This is a 3-level referral model. You earn small but steady rewards from people you invite, and also from users they invite (level 2), and even from level 3 referrals.
                        <br />
                        <strong>You get:</strong>
                        <br />+ 5% from all payments made by users you directly invited (level 1)
                        <br />+ 2.5% from payments made by level 2 users
                        <br />+ 1.25% from payments made by level 3 users
                        <br />
                        These rewards apply to both subscription fees and account top-ups. They are paid for 5 full years starting from the moment each user makes their first payment. After 5 years, rewards for that user stop.
                        <br />
                        All earnings are calculated after the payment system fees are deducted. You can track everything clearly in your reports.
                        <br />
                        In total, you can <strong>earn up to 8.75%</strong> across all levels from each user over a 5-year period.
                        <br />
                        <strong>Why it’s awesome:</strong>
                        <br />
                        This model is perfect if you're playing the long game. Even with modest percentages, the extended earning window means reliable, long-term passive income. You don't have to constantly bring in new users — just a few good ones can keep paying you for years.
                        <br />
                        It's steady, low-pressure, and great for building a base of recurring commissions without burnout.
                    </>
                );


            default:
                return "Select an affiliate model to see details.";
        }
    };

    return (
        <div className="p-3">
            {/* Заголовок и бейджи */}
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 gap-2">
                {/* Заголовок слева */}
                <h6 className="text-success mb-0">Set Your Affiliate Reward Type</h6>

                {/* Информация справа */}
                <div className="d-flex flex-column flex-md-row text-md-end gap-1 gap-md-4">
                    <h6 className="text-muted small mb-0">
                        Current Reward Model: <strong>{user?.user?.affiliate_model === "OFF" ? "VIRT" : user?.user?.affiliate_model}</strong>
                    </h6>
                    <h6 className="text-muted small mb-0">
                        Affiliate Balance: <strong>${user.user.affiliate_balance?.toFixed(2)}</strong>
                    </h6>
                </div>
            </div>


            {/* Селект + кнопка */}
            <div className="d-flex flex-column flex-md-row gap-3 mb-3 w-100">
                <Form.Group className="flex-grow-1">
                    <Form.Label className="small text-muted mb-1">
                        Set Type, see description below:
                    </Form.Label>
                    <Form.Select
                        size="sm"
                        value={selectedModel}
                        onChange={(e) => setSelectedModel(e.target.value)}
                        className="text-muted"
                    >
                        {models.map((m) => (
                            <option key={m.value} value={m.value} className="text-muted">
                                {m.label}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>

                <div className="d-flex align-items-end">
                    <Button
                        variant="success"
                        size="sm"
                        className="w-100 w-md-auto"
                        disabled={loading}
                        onClick={handleSave}
                    >
                        {loading ? <Spinner size="sm" animation="border" /> : "Save Affiliate Reward Type"}
                    </Button>
                </div>
            </div>

            {/* Описание модели */}
            <div className="small text-muted mb-3">
                <strong>This Model Details:</strong><br />
                {getModelDescription(selectedModel)}
            </div>

            {/* Калькулятор + пояснение */}
            <div className="small text-muted">
                <AffiliateEarningsCalculator />

                <p className="mt-3 mb-1"><strong>NOTE:</strong></p>
                <p>
                    <em>Important to understand:</em> The affiliate model you choose applies <strong>only to users who register after you change the model</strong>. It does <strong>not</strong> affect users who registered earlier.<br />
                    For example: if you selected <strong>1Y-20</strong> and invited user A, then switched to <strong>ONETIME-50</strong> for user B — you will continue to earn long-term from A, and one-time from B.<br />
                    You can <strong>change the model any time</strong>. Try what works best!
                </p>
            </div>
        </div>


    );
};

export default SetAffiliateModel;
